.lightbox-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;background:#000000d9;display:flex;align-items:center;justify-content:center;z-index:1000}.lightbox-image{max-width:90%;max-height:90%;border-radius:8px;box-shadow:0 0 12px #00000080}
/*# sourceMappingURL=lightbox-image-dialog.component-RG4W2T6B.css.map */
